var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCloseIcon = function SvgXCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.367 2.133A1.25 1.25 0 0 1 2.133.367L10 8.234 17.867.367a1.25 1.25 0 0 1 1.766 1.766L11.766 10l7.867 7.867a1.25 1.25 0 0 1-1.766 1.766L10 11.766l-7.867 7.867a1.25 1.25 0 0 1-1.766-1.766L8.234 10z"
  })));
};
export default SvgXCloseIcon;